import { useState, useEffect } from 'react';

export default function useBranch(test: any) {
  const [testResult, setTestResult] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    Promise.resolve(test)
      .then((res: any) => mounted && setTestResult(res))
      .catch(() => mounted && setTestResult(undefined))
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, [test, setTestResult, setLoading]);

  return {
    testResult,
    loading,
  };
}
